'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.controller('LanguageCtrl', function($window, $rootScope, $translate, tmhDynamicLocale, 
  $location, $anchorScroll, $cookies, cookieService) {
  // Angular i18n locale files found in /resources/lang/ are from:
  // https://github.com/angular/angular.js/tree/master/src/ngLocale

  this.currentLanguage = function() {
    return $translate.use();
  };

  this.scrollTo = function(category) {
    // set the location.hash to the id of the element you wish to scroll to.
    $location.hash(category);
    $anchorScroll();
    angular.element('#' + category).focus();
  };

  $window.addEventListener('language-switched', function($event) {
    var locale = $cookies.get('language');
    if (!locale) {
      if ($event && $event.detail) {
        locale = $event.detail;
        locale = locale === 'fr' ? 'fr' : 'en';
        cookieService.setLanguageCookie(locale);
      }
    }
    tmhDynamicLocale.set(locale + '-ca')
    .then(()=>$translate.use(locale))
    .then(()=>$rootScope.$broadcast('languageSwitched'));
  });
});
